'use strict';

class CallCenterEditController {
  constructor($log,
              $q,
              $rootScope,
              $scope,
              $filter,
              $state,
              utils,
              config,
              MonitoringService,
              UsersService,
              LocationsService,
              EditLocationDataProvider,
              QuestionsService,
              ToastsService,
              I18nService) {

    // #region Define Fields

    const $t = $filter('translate');
    const CURRENT_ADMIN_LOCAL_STORAGE_KEY = 'App-Admin';
    const SELECTED_LOCATION_STORAGE_KEY = 'Selected-Location';
    const SELECTED_CALLCENTER_LOCAL_STORAGE_KEY = 'Selected-CallCenter';
    const SELECTED_USER_LOCAL_STORAGE_KEY = 'Selected-User';

    // Data provider
    let dataProvider = new EditLocationDataProvider();
    $scope.dataProvider = dataProvider;

    let locationId = $state.params && $state.params.locationId;
    $scope.locationId = parseInt(locationId);
    $scope.currentUser = utils.getStorageItem(CURRENT_ADMIN_LOCAL_STORAGE_KEY);
    $scope.locationInfo = utils.getStorageItem(SELECTED_LOCATION_STORAGE_KEY);
    $scope.dateFormat = $t('datetime.mdyHM12');
    $scope.callCenter = utils.getStorageItem(SELECTED_CALLCENTER_LOCAL_STORAGE_KEY);

    // Location services and questions
    const answerStatuses = config.getConfigByKey('questionAnswerStatuses');
    const availableResponseTypes = [2, 10, 7];
    $scope.answerStatuses = answerStatuses.filter(el => !el.hidden);

    // Call Center Statuses & Phone Types
    $scope.callCenterStatuses = config.getConfigByKey('callCenterStatuses');
    $scope.callCenterAlertStatuses = config.getConfigByKey('callCenterAlertStatuses');
    $scope.callCenterAlertSources = config.getConfigByKey('callCenterAlertSources');
    $scope.phoneTypes = config.getConfigByKey('phoneTypes');

    // Call Center Tests
    $scope.callCenterTestStatuses = config.getConfigByKey('callCenterTestStatuses');
    $scope.testDurationPresets = [
      { key: 30, value: 'callCenter.tests.presets.30m' },
      { key: 60, value: 'callCenter.tests.presets.1h' },
      { key: 120, value: 'callCenter.tests.presets.2h' },
    ];
    $scope.testDurationKey = 30;

    // Datepicker options
    const today = new Date();
    $scope.testStartDate = today;
    $scope.testDatePickerOptions = {
      language: I18nService.getLocale()?.code || 'en',
      position: 'bottom left',
      view: 'days',
      minView: 'days',
      autoClose: true,
      minDate: today,
      maxDate: new Date().setDate(today.getDate() + 30),
      dateFormat: 'm/dd/yyyy',
      timepicker: true,
      timeFormat: 'hh:mm AA',
    };

    $scope.registrationMsg = '';
    $scope.alertsLoading = false;
    $scope.isMoreAlerts = false;
    $scope.limitContacts = 3; // Limit Call Center contacts
    $scope.addingOwner = false; // Trigger the owner changing
    $scope.suggestedContacts = false; // Flag to show suggested contacts
    $scope.showDispatch = false; // Hide notDispatch toggle by default

    // Initial alerts
    let alertsLoaded = false;
    let contactsLoaded = false;
    $scope.visiblePages = 1;
    $scope.isMoreAlerts = false;
    $scope.historyFilter = {
      alertStatus: null,
      alertSource: null
    };

    const REQUEST_LIMIT = 100;

    const locationTimeZoneId = ($scope.locationInfo.timezone && !!moment.tz.zone($scope.locationInfo.timezone.id))
      ? $scope.locationInfo.timezone.id
      : 'GMT';
    $scope.locationTimeZoneOffset = locationTimeZoneId
      ? moment().tz(locationTimeZoneId).format('Z')
      : 'GMT';
    $scope.timeFormatStr = $t('datetime.events.date');
    $scope.timestampFormatStr = $t('datetime.HMS12');
    $scope.datepickerFormat = $t('datetime.mdyHM12');

    // Navigaiton Tabs
    $scope.tabs = [
      {
        id: 'details',
        name: $t('form.details'),
        icon: 'far fa-file-alt'
      },
      {
        id: 'contacts',
        name: $t('form.contacts'),
        icon: 'iotr fa-friends'
      },
      {
        id: 'relations',
        name: $t('bots.relations'),
        icon: 'far fa-link'
      },
      {
        id: 'tests',
        name: $t('callCenter.tests.title'),
        icon: 'far fa-vial'
      },
      {
        id: 'history',
        name: $t('common.history'),
        icon: 'far fa-history'
      }
    ];

    // #endregion

    // Put on scope only the stuff we really need there
    angular.extend($scope, {
      back: back,
      updateCallCenter: updateCallCenter,
      goToAddUser: goToAddUser,
      searchUsers: searchUsers,
      getCallCenterStatus: getCallCenterStatus,

      // Details
      isDetailsChanged: isDetailsChanged,
      onToggleAgDnd: onToggleAgDnd,
      availableToAnswer: availableToAnswer,
      onEditQuestionButtonClick: onEditQuestionButtonClick,
      updateAnswer: updateAnswer,

      // Contacts
      addUser: addUser,
      viewUser: viewUser,
      editContact: editContact,
      saveContact: saveContact,
      removeContact: removeContact,
      canRemoveContact: canRemoveContact,

      // Relations
      generateAddress: generateAddress,

      // Alerts
      getAlertStatus: getAlertStatus,
      processAlerts: processAlerts,

      // Call Center Test
      callCenterTest: callCenterTest,
      cancelTest: cancelTest,
    });

    // #region Forms Validation

    $('#form-status').form({
      inline: true,
      fields: {
        'codeword': {
          rules: [
            {
              type: 'regExp[/^[A-Za-z0-9s]{3,32}$|^$/gi]', // 3-32 chars and digits or empty
              prompt: $t('prompt.locations.callCenter.codeword')
            }
          ]
        }
      }
    });

    $('#form-search-users').form({
      inline: true,
      fields: {
        'user-search': {
          rules: [
            {
              type: 'empty',
              prompt: $t('prompt.empty')
            }
          ]
        }
      }
    });

    $('#contact-edit-form').form({
      inline: true,
      fields: {
        'firstName': {
          rules: [
            {
              type: 'empty',
              prompt: $t('prompt.empty')
            },
          ]
        },
        'lastName': {
          rules: [
            {
              type: 'empty',
              prompt: $t('prompt.empty')
            },
          ]
        },
        'phone': {
          rules: [
            {
              type: 'empty',
              prompt: $t('prompt.empty')
            },
            {
              type: 'regExp[/^[0-9]{10,15}$/gi]', // 10-15 digits
              prompt: $t('prompt.signup.phone.length')
            },
          ]
        }
      }
    });

    // Initialize form validation rules
    $('#callcenter-test-form').form({
      inline: true,
      fields: {
        'testComment': {
          rules: [
            {
              type: 'empty',
              prompt: $t('callCenter.tests.createTest.emptyCommentPrompt')
            },
            {
              type: 'maxLength[300]',
              prompt: $t('callCenter.tests.createTest.longCommentPrompt')
            }
          ]
        },
      }
    });

    // #endregion

    // Sortable contact list
    $('#contacts-list').sortable({
      placeholder: 'sortable-list-placeholder',
      cursor: 'grabbing',
      opacity: 0.8,
      update: function(event, ui) {
        $scope.$applyAsync(() => {
          let sortedIndexes = $('#contacts-list').sortable('toArray'); // e.g. ['3', '1', '2']
          $scope.callCenter.contacts = sortedIndexes
            .map(indexStr => $scope.callCenter.contacts[parseInt(indexStr)]);
          saveReorderedContacts();
        });
      }
    });

    // Remove Modals
    $scope.$on('$destroy', () => {
      $('#contact-edit-modal').remove();
      $('#answer-modal').remove();
      $('#callcenter-test-modal').remove();
    });

    // #region Main Methods

    function back() {
      $scope.loading = false;
      if (!$scope.locationId) {
        $state.go('main.locations.list');
        $rootScope.$emit('refreshChooseMenuEvent', 'locations');
      } else {
        $state.go('main.locations.edit', {
          tab: 'users',
          locationId: $scope.locationId
        });
        $rootScope.$emit('refreshChooseMenuEvent', 'locations');
      }
    }

    function initPage() {
      // If opened not directly from Location Edit page
      if (!$scope.locationId || $scope.locationId !== $scope.locationInfo.id) {
        return back();
      }

      // Inital API calls
      $q.all([
        getCallCenterDetails(true),
        $scope.dataProvider.callCenterServiceResource.init(),
        $scope.dataProvider.locationServicesStateResource.init(),
      ]).then(() => {
        initCallCenterQuestions();
        $scope.loading = false;
      }, (err) => {
        $scope.loading = false;
        utils.handleApiError(err);
      });

      // API calls separation
      $scope.$watch('activeTab', function(newValue, oldValue) {
        switch (newValue) {
          case 'history':
            if (!alertsLoaded) {
              initHistoryTab();
            }
            break;
          case 'contacts':
            if (!contactsLoaded) {
              initContactsTab();
            }
        }
      });

      // Watch for alerts filters and pagination
      $scope.$watchGroup([
        'historyFilter.alertStatus',
        'historyFilter.alertSource'
      ], () => processAlerts());

      // Watch for the location state 'services' changes
      $scope.$watch('dataProvider.locationServicesStateResource.value', (newValue, oldValue) => {
        if (oldValue && $scope.dataProvider.callCenterServiceResource.value && $scope.dataProvider.callCenterServiceResource.value.collection_id) {
          $scope.loading = true;

          initCallCenterQuestions()
            .then(() => {
              $scope.loading = false;
            }, (err) => {
              $scope.loading = false;
            });
        }
      });
    }

    function getCallCenterDetails(initial) {
      $scope.loading = true;

      return getCallCenter(initial)
        .then(data => {
          $scope.callCenter = data;
          $scope.callCenterBack = angular.copy(data);
          processCallCenterTests();

          // If has registration errors
          if ($scope.callCenter.missingFields && $scope.callCenter.missingFields.length > 0) {
            $scope.registrationMsg = $t('callCenter.registration.missingFieldsMsg');
            $scope.callCenter.missingFields.forEach((element, index) => {
              $scope.registrationMsg += '<a class="text red">' + $t('callCenter.registration.fields.' + element) + '</a>';
              $scope.registrationMsg += (index < $scope.callCenter.missingFields.length - 1) ? ', ' : '.';
            });
          }

          // Get owner info
          if ($scope.callCenter.userId) {
            return getUser($scope.callCenter.userId);
          }
        })
        .then(() => {
          $scope.loading = false
        })
        .catch(err => {
          $scope.loading = false;
          utils.handleApiError(err);
        });
    }

    function getCallCenter(initial) {
      // Skip getting Call Center info
      // if (initial && $scope.callCenter) {
      //   return $q.when($scope.callCenter);
      // }

      return MonitoringService.getCallCenter($scope.locationId)
        .then(data => {
          if (data && data.callCenter) {
            let statusObj = $scope.callCenterStatuses.find(status => {
              return data.callCenter.status === status.id;
            });
            data.callCenter.statusDesc = statusObj ? $t(statusObj.name) : $t('common.undefinedStatus');
            utils.setStorageItem(SELECTED_CALLCENTER_LOCAL_STORAGE_KEY, data.callCenter);
            return data.callCenter;
          } else {
            console.log('Something going wrong!');
          }
        }, err => {
          $scope.loading = false;
          $scope.alertsLoading = false;
          utils.handleApiError(err);
        });
    }

    function getCallCenterStatus() {
      if ($scope.callCenter.code) {
        return $scope.callCenter.statusDesc + ' / ' + $scope.callCenter.code;
      }
      return $scope.callCenter.statusDesc;
    }

    /**
     * Getting related user by ID
     * @param {number} userId User ID
     */
    function getUser(userId) {
      return UsersService.getUserInfo(userId)
        .then(data => {
          $scope.userInfo = data.user;
          $scope.loading = false;
        }, err => {
          $scope.userInfo = undefined;
          $scope.loading = false;
          $scope.alertsLoading = false;
          utils.handleApiError(err);
        });
    }

    /**
     * Returns Call Center alert status
     * @param {number} status
     */
    function getAlertStatus(status) {
      if (status) {
        let alertStatus = $scope.callCenterAlertStatuses.find(res => res.id === status);
        if (alertStatus) {
          return alertStatus;
        }
      }
      // Otherwise set show alertStatus 0
      return $scope.callCenterAlertStatuses[0];
    }

    /**
     * Get Questions API for related to Call Center service,
     * otherwise show "notDispatch" toggle from Call Center API
     */
     function initCallCenterQuestions() {
      const callCenterService = angular.copy($scope.dataProvider.callCenterServiceResource.value);

      if (!callCenterService || !callCenterService.collection_id) {
        $scope.showDispatch = true;
        return;
      }

      const answerStatuses = config.getConfigByKey('questionAnswerStatuses')
        .filter(el => !el.hidden) // All except "obsolete" and "replaced"
        .map((el) => el.id);
      return QuestionsService.getLocationQuestions($scope.locationId, {
        answerStatus: answerStatuses,
        collectionName: callCenterService.collection_id
      })
        .then((data) => {
          if (!data || !data.questions || data.questions.length === 0) {
            $scope.showDispatch = true;
            return;
          }

          $scope.questions = [];
          data.questions.forEach((question) => {

            // TODO: Remove this when collectionName filter will work
            if (!question.collection || question.collection.name !== callCenterService.collection_id) {
              return;
            }

            question.answer = fixAnswer(question);
            question.answerDesc = getAnswerDesc(question);
            $scope.questions.push(question);
          });
        }, err => {
          $scope.showDispatch = true;
          utils.handleApiError(err);
        });
    }

    /**
     * Use current or default answer
     * @param {*} question
     * @return {string|boolean|undefined}
     */
     function fixAnswer(question) {
      if (!question) {
        return undefined;
      }

      // Status of the question (1 - initial, 2 - available, 3 - skipped, 4 - answered)
      let answer = (question.status === 1 || question.status === 2) ? question.defaultAnswer : question.answer;
      if (question.responseType === 1) { // Fix boolean answer
        answer = (answer === 'true' || answer === '1' || answer === true) ? true : false;
        return answer;
      } else if (question.responseType === 2 && question.responseOptions) { // Fix answer with options
        let selectedOption = question.responseOptions.find(option => option.id === parseInt(answer));
        return selectedOption?.id ?? answer;
      }

      return answer;
    }

    /**
     * Get question description
     * @param {*} question
     * @returns {string}
     */
    function getAnswerDesc(question) {
      if (!question) {
        return undefined;
      }

      // Status of the question (1 - initial, 2 - available, 3 - skipped, 4 - answered)
      let answer = (question.status === 1 || question.status === 2) ? question.defaultAnswer : question.answer;
      if (question.responseType === 1) { // Fix boolean answer
        answer = (answer === 'true' || answer === '1' || answer === true) ? true : false;
        return answer;
      } else if (question.responseType === 2 && question.responseOptions) { // Fix answer with options
        let selectedOption = question.responseOptions.find(option => option.id === parseInt(answer));
        return selectedOption?.text || answer;
      } else if (question.responseType === 7) {
        return (answer != null && question.slider?.unitsDesc != null)
          ? `${answer} ${question.slider?.unitsDesc}`
          : answer;
      }

      return answer;
    }

    /**
     * Check if question available for answer
     * @param question
     * @return {boolean}
     */
     function availableToAnswer(question) {
      if (!question || !question.editable) {
        return false;
      }
      return availableResponseTypes.some(type => question.responseType === type);
    }

    /**
     * Test for details tab form changes
     * @returns boolean
     */
    function isDetailsChanged() {
      if ($scope.callCenter && $scope.callCenterBack) {
        // Test if permit ID changed
        if ($scope.callCenter.permit && $scope.callCenter.permit !== $scope.callCenterBack.permit) {
          return true;
        }
        // Test if codeword changed and does not contain stars
        if ($scope.callCenter.codeword !== $scope.callCenterBack.codeword) {
          return true;
        }
      }
      return false;
    }

    /**
     * On toggle original DND switch
     * @returns {Primise}
     */
    function onToggleAgDnd() {
      let attrs = {
        notDispatch: $scope.callCenter.notDispatch
      };
      return updateCallCenter(attrs, false, true)
        .catch(err => {
          $scope.callCenter.notDispatch = angular.copy(!$scope.callCenter.notDispatch);
          utils.handleApiError(err);
        });
    }

    /**
     * Update question answer
     * @return {Promise}
     */
     function updateAnswer(question) {
      if ($scope.loading) {
        return;
      }

      $scope.loading = true;
      $scope.dataProvider.updateQuestionAnswer(question)
        .then((data) => {
          // Show toast only for singe-toggle question
          if (question.responseType === 1 && question.displayType === 2) {
            ToastsService.success($t('locations.edit.services.successMsg'));
          }

          // Update question in the list only for modal
          if ($scope.selectedQuestion) {
            let questionIndex = $scope.questions.findIndex(q => q.id === $scope.selectedQuestion.id);
            let newQuestionInfo = data.questions[0];
            $scope.questions[questionIndex].answer = fixAnswer(newQuestionInfo);
            $scope.questions[questionIndex].answerDesc = getAnswerDesc(newQuestionInfo);
          }

          $scope.loading = false;
        }, (err) => {
          utils.handleApiError(err);
          $scope.loading = false;
        });
    }

    function onEditQuestionButtonClick(question) {
      // Test supported response types
      if ($scope.loading || !availableToAnswer(question)) {
        return;
      }

      let selectedQuestion = angular.copy(question);

      // Set selected option for dropdown
      if (selectedQuestion.responseType === 2) {
        let selectedOption = selectedQuestion.responseOptions?.find(el => parseInt(el.id) === parseInt(selectedQuestion.answer));
        selectedQuestion.answer = selectedOption ? selectedOption.id : undefined;
        $scope.selectedAnswer = selectedOption;

      } else if (selectedQuestion.responseType === 7) {
        $scope.sliderMin = selectedQuestion.slider?.min;
        $scope.sliderMax = selectedQuestion.slider?.max;
        $scope.sliderStep = selectedQuestion.slider?.inc;
        $scope.sliderUnits = selectedQuestion.slider?.unitsDesc;

        if (selectedQuestion.displayType === 0) {
          $scope.sliderMin = $scope.sliderMin == null ? 0 : $scope.sliderMin;
          $scope.sliderMax = $scope.sliderMax == null ? 100 : $scope.sliderMax;
          $scope.sliderStep = $scope.sliderStep == null ? 1 : $scope.sliderStep;
        }
      }
      $scope.selectedQuestion = selectedQuestion;

      $('#answer-modal').modal({
        autofocus: false,
        onApprove: () => {
          $scope.$applyAsync(() => {
            updateAnswer($scope.selectedQuestion);
            $scope.selectedQuestion = undefined;
            $('#answer-modal').modal('hide');
          });
        },
      }).modal('show');
    }

    /**
     * Update Call Center data
     * @param {Object} [attrs] Details to update
     * @param {boolean} [isSilent] If no need to show loading
     * @param {boolean} [noValidation] Set to don't validate codeword
     * @returns {Promise}
     */
    function updateCallCenter(attrs, isSilent, noValidation) {
      let params = {
        callCenter: attrs ? attrs : {
          permit: $scope.callCenter.permit,
          notDispatch: $scope.callCenter.notDispatch,
        }
      };
      // Test codeword only if it was changed
      if (!noValidation && $scope.callCenter.codeword !== $scope.callCenterBack.codeword) {
        $('#form-status').form('validate form');
        if (!$('#form-status').form('is valid')) {
          return;
        }
        params.callCenter.codeword = $scope.callCenter.codeword || '';
      }

      $scope.loading = !isSilent;
      return MonitoringService.updateCallCenter(params, $scope.locationInfo.id)
        .then(data => {
          $scope.loading = false;
          $scope.callCenterBack.permit = angular.copy($scope.callCenter.permit);
          $scope.callCenterBack.notDispatch = angular.copy($scope.callCenter.notDispatch);
          ToastsService.success();
          utils.setStorageItem(SELECTED_CALLCENTER_LOCAL_STORAGE_KEY, $scope.callCenter);
          return $q.resolve(data);
        }, err => {
          $scope.loading = false;
          $scope.alertsLoading = false;
          if (err && err.resultCode === 6) {
            ToastsService.warning($t('callCenter.registration.userHasNoAccess'), $t('callCenter.registration.userHasNoAccessMsg'));
            return;
          }
          utils.handleApiError(err);
        });
    }

    initPage();

    // #endregion

    // #region Contacts Tab

    function initContactsTab() {
      if ($scope.callCenter && (!$scope.callCenter.contacts || ($scope.callCenter.contacts && $scope.callCenter.contacts.length < $scope.limitContacts))) {
        $scope.suggestedContacts = true;
        getLocationUsers(false, true);
      }
    }

    /**
     * Redirects to the users list to add into Call Center
     * @param {boolean} [changeTab] Change tab to 'contacts'
     */
    function goToAddUser(changeTab) {
      delete $scope.searchUserList;
      $scope.userExist = false;
      $scope.addingOwner = !!changeTab;

      if (changeTab) {
        $scope.activeTab = 'contacts';
        $scope.suggestedContacts = false;
        return getLocationUsers(true);
      } else {
        // Get suggested contacts
        if (!$scope.suggestedContacts) {
          $scope.suggestedContacts = true;
          getLocationUsers();
        }
      }

      $('#form-search-users').form('clear');
      $('#input-user-email').trigger('focus');
    }

    /**
     * Search users across Cloud to add as a contacts
     */
    function searchUsers() {
      // Scroll fix
      $('html, body').animate({
        scrollTop: parseInt($('#form-search-users').offset().top) - 120
      }, 500);

      $scope.suggestedContacts = false;
      $scope.completedSearch = false;
      delete $scope.hideSearchHint;
      delete $scope.searchUserList;
      $scope.userExist = false;

      if (!$('#form-search-users').form('is valid')) {
        return;
      }

      $scope.usersLoading = true;
      // We are not sending Org Id here to explicitly tell API that we want to search across all Orgs
      return UsersService.getUsersByParams(null, { searchBy: $scope.addUserSearchVal + '*', limit: 10 })
        .then(data => {
          $scope.completedSearch = true;
          $scope.usersLoading = false;
          $scope.searchUserList = [];
          if (data.users && data.users.length !== 0) { // Exist

            // Filter out user who already an owner
            $scope.searchUserList = data.users.filter(u => {
              if ($scope.callCenter.userId) {
                if (data.users.length === 1 && $scope.callCenter.userId === u.id) {
                  $scope.userExist = true;
                  return false;
                }
                return $scope.callCenter.userId !== u.id;
              } else {
                return true;
              }
            });

          } else {
            // Looks like the user wasn't found at all and we might need to warn user with log warning
            $log.warn('Specified user was not found in Maestro!');
          }
        })
        .catch(err => {
          $scope.loading = false;
          $scope.alertsLoading = false;
          utils.handleApiError(err);
        });
    }

    /**
     * Returns a location users by locationAccess
     * @param {boolean} [adminsOnly] Get only location administrators
     */
    function getLocationUsers(adminsOnly, initial) {
      // Scroll fix
      if (!initial) {
        $('html, body').animate({
          scrollTop: parseInt($('#form-search-users').offset().top)
        }, 500);
      }

      $scope.completedSearch = false;
      delete $scope.hideSearchHint;
      $scope.usersLoading = true;
      contactsLoaded = true;

      return LocationsService.getLocationUsers($scope.locationInfo.id)
        .then((data) => {
          $scope.completedSearch = true;
          if (!data || !data.users || data.users.length === 0) {
            $scope.usersLoading = false;
            $scope.userExist = true;
            return;
          }

          $scope.searchUserList = data.users.filter(u => {
            let result = true;
            // Filter out existing service owner
            if ($scope.callCenter.userId) {
              result = u.id !== $scope.callCenter.userId;
              $scope.userExist = !result && data.users.length === 1;
            }
            // Test administrative access
            if (result && adminsOnly) {
              result = u.locationAccess === 30;
            }
            // Test for existing contacts
            if (result && $scope.callCenter.contacts && $scope.callCenter.contacts.length) {
              result = !$scope.callCenter.contacts.some(a => a.phone === u.phone);
            }
            return result;
          });
          $scope.usersLoading = false;
        });
    }

    /**
     * Add user to contacts or set as service owner
     * @param {Object} user User data
     */
    function addUser(user) {
      let params = {};
      let silent = true;
      if ($scope.addingOwner) { // Assign Call Center owner
        delete $scope.hideSearchHint;
        delete $scope.searchUserList;
        $scope.completedSearch = false;
        $scope.addingOwner = false;
        $scope.userExist = false;
        // $scope.activeTab = 'details';
        silent = false;
        contactsLoaded = false;
        params.userId = user.id;
      } else { // Add user to Call Center contacts
        if (!user.phone) {
          ToastsService.error($t('users.list.noPhoneError'), $t('users.list.noPhoneError-desc'));
          return;
        }
        params.contacts = angular.copy($scope.callCenterBack.contacts) || [];
        params.contacts.push({
          userId: user.id,
          // firstName: user.firstName,
          // lastName: user.lastName,
          // phone: user.phone,
          // phoneType: user.phoneType
        });
      }

      return updateCallCenter(params, silent)
        .then(data => {
          return getCallCenterDetails();
        });
    }

    function saveReorderedContacts() {
      $scope.loading = true;
      let params = {};
      params.contacts = angular.copy($scope.callCenter.contacts) || [];
      return updateCallCenter(params, true).then(data => {
        if (data && data.resultCode === 0) {
          return getCallCenterDetails();
        }
      });
    }

    /**
     * Forward to User Details UI
     * @param {Object} user User data
     */
    function viewUser(user) {
      utils.setStorageItem(SELECTED_USER_LOCAL_STORAGE_KEY, user);
      $state.go('main.users.edit', {
        from: 'callcenter',
        locationId: $scope.locationInfo.id
      });
    }

    function editContact($index) {
      $scope.selectedContactIndex = $index;
      $scope.selectedContact = angular.copy($scope.callCenterBack.contacts[$index]);
      $('#contact-edit-modal').modal({
        autofocus: false
      }).modal('show');
    }

    /**
     * Update Call Center contact
     * @param {Object} details Contact details
     */
    function saveContact() {
      let params = {};
      params.contacts = angular.copy($scope.callCenterBack.contacts);
      params.contacts[$scope.selectedContactIndex] = $scope.selectedContact;
      $('#contact-edit-modal').modal('hide');
      return updateCallCenter(params, true)
        .then(data => {
          if (data && data.resultCode === 0) {
            $scope.callCenter.contacts = params.contacts;
            $scope.callCenterBack.contacts = angular.copy(params.contacts);
            utils.setStorageItem(SELECTED_CALLCENTER_LOCAL_STORAGE_KEY, $scope.callCenter);
            ToastsService.success();
          }
        });
    }

    function canRemoveContact(contact) {
      if (!$scope.callCenter || !$scope.callCenter.contacts) {
        return false;
      }
      if ([0, 4, 5].includes($scope.callCenter.status)) {
        return true;
      }
      return $scope.callCenter.contacts.length > 1;
    }

    function removeContact($index) {
      $('#contact-remove-dialog').modal({
        closable: true,
        detachable: true,
        onApprove: function() {
          removeCallCenterContact($index);
        }
      }).modal('show');
    }

    /**
     * Remove Call Center contact
     * @param {number} index
     */
    function removeCallCenterContact($index) {
      if (!canRemoveContact($scope.callCenter.contacts[$index])) {
        return;
      }
      let params = {};
      params.contacts = angular.copy($scope.callCenterBack.contacts);
      params.contacts.splice($index, 1);
      return updateCallCenter(params, true)
        .then(data => {
          if (data && data.resultCode === 0) {
            $scope.callCenter.contacts = params.contacts;
            $scope.callCenterBack.contacts = angular.copy(params.contacts);
            utils.setStorageItem(SELECTED_CALLCENTER_LOCAL_STORAGE_KEY, $scope.callCenter);
            $('#contact-remove-dialog').modal('hide');
          }
        });
    }

    // #endregion

    // #region Relations Tab

    function generateAddress(location) {
      let address = utils.generateAddress(location);
      if (!address) {
        return $t('common.unknown-address');
      }
      return address;
    }

    // #endregion

    // #region History of Alerts Tab

    function initHistoryTab() {
      getCallCenterAlerts();
    }

    function getCallCenterAlerts() {
      $scope.alertsLoading = true;
      let params = {
        sortBy: 'alertDateMs',
        sortOrder: 'desc'
      };

      return MonitoringService.getCallCenterAlerts(locationId, params)
        .then(data => {
          $scope.alertsTotal = data.callCenterAlerts || [];
          alertsLoaded = true;
          return processAlerts();
        }, err => {
          $scope.loading = false;
          $scope.alertsLoading = false;
          utils.handleApiError(err);
        });
    }

    /* Virtual pagination for alerts */
    function processAlerts(showMore) {
      $scope.alertsLoading = true;
      if (!$scope.alertsTotal || !$scope.alertsTotal.length) {
        $scope.alertsLoading = false;
        return $scope.alerts = [];
      }

      // Each new filtration reset page count back to 1
      $scope.visiblePages = showMore ? $scope.visiblePages + 1 : 1;

      let counter = 0;
      let alerts = $scope.alertsTotal.filter(item => {
        let result = $scope.historyFilter.alertStatus === null
          ? true
          : item.alertStatus === $scope.historyFilter.alertStatus;
        result = (result && $scope.historyFilter.alertSource === null)
          ? true
          : item.alertSourceType === $scope.historyFilter.alertSource;
        if (result) {
          counter++;
        }
        return result;
      }).slice(0, $scope.visiblePages * REQUEST_LIMIT);

      $scope.$applyAsync(() => {
        $scope.isMoreAlerts = counter > $scope.visiblePages * REQUEST_LIMIT;
        $scope.alerts = alerts;
        $scope.alertsLoading = false;
      });
    }

    // #endregion

    // #region Call Center Test Tab

    function processCallCenterTests() {
      $scope.tests = [];

      // Process call center tests
      $scope.callCenter?.tests && $scope.callCenter.tests.map(test => {
        let testStatus = $scope.callCenterTestStatuses.find(status => status.id === test.status);
        test.statusColor = testStatus?.color + '-mark';
        test.statusDesc = testStatus ? $t(testStatus.name) : $t('common.unknown');
        test.duration = Math.round(utils.timeDifference(test.startDate, test.endDate, 'hours'));

        // Generate custom name
        const startDate = moment(test.startDate);
        const endDate = moment(test.endDate);
        const diff = moment.duration(endDate.diff(startDate)).asMinutes();
        if (diff === 30 || diff === 60 || diff === 120) { // Duration presets
          let preset = $scope.testDurationPresets.find(p => p.key === diff);
          test.name = preset && preset.value ? $t(preset.value) : $t('callCenter.tests.presets.custom');
        } else {
          test.name = $t('callCenter.tests.presets.custom');
        }

        $scope.tests.push(test);
      });
    }

    function callCenterTest() {
      if (!$scope.callCenter || $scope.callCenter.status !== 3) {
        return;
      }

      // Adjust available start date
      const now = new Date();
      const nowFuture = new Date().setTime(now.getTime() + (5 * 60 * 1000));
      $scope.testDatePickerOptions.minDate = nowFuture;
      $scope.testStartDate = nowFuture;

      $('#callcenter-test-modal').modal({
        autofocus: false,
        closable: false,
        onApprove: () => {
          $('#callcenter-test-form').form('validate form');
          if ($('#callcenter-test-form').form('is valid')) {
            $scope.$applyAsync(() => {
              $('#answer-modal').modal('hide');
              createCallCenterTest();
            });
          } else {
            // Do not close modal
            return false;
          }
        }
      }).modal('show');
    }

    function createCallCenterTest() {
      $scope.testLoading = true;
      const startDateStr = $scope.testStartDate?.toISOString();
      const endDateStr = moment($scope.testStartDate).add($scope.testDurationKey, 'm').toISOString();

      return MonitoringService.createCallCenterTest($scope.locationId, {
        startDate: startDateStr,
        endDate: endDateStr,
        comment: $scope.testComment
      })
        .then(data => {
          if (data && data.resultCode === 0) {
            ToastsService.success($t('callCenter.tests.createTest.successMsg'));

            // Reset default values
            $scope.testDurationKey = '0';
            $scope.testComment = undefined;

            // Take time to update
            setTimeout(() => {
              getCallCenterDetails();
              $scope.testLoading = false;
            }, 2000);
          } else {
            $scope.testLoading = false;
          }
        }, err => {
          $scope.testLoading = false;
          utils.handleApiError(err);
        });
    }

    function cancelTest(test) {
      $scope.testLoading = true;
      return MonitoringService.cancelCallCenterTest($scope.locationId, test.testId)
        .then(data => {
          if (data && data.resultCode === 0) {
            ToastsService.success($t('callCenter.tests.cancelTestMsg'));
          }
          // Take time to update
          setTimeout(() => {
            getCallCenterDetails();
            $scope.testLoading = false;
          }, 2000);
        }, err => {
          utils.handleApiError(err);
          // Some tests can be expired
          setTimeout(() => {
            getCallCenterDetails();
            $scope.testLoading = false;
          }, 2000);
        });
    }

    // #endregion
  }
}

export default angular
  .module('main.callCenterEdit.controller', [])
  .controller('CallCenterEditController', CallCenterEditController)
  .name;
